import { gql } from '@apollo/client';

import { studentFragment } from '../fragments';

export default gql`
  mutation AddStudentsToCourse(
    $courseId: String!
    $input: AddStudentsToCourseInput!
  ) {
    student(courseId: $courseId, input: $input)
      @rest(
        type: "Student"
        path: "courses/{args.courseId}/students/addMultiple"
        method: "POST"
      ) {
      ...Student
    }
  }
  ${studentFragment}
`;
